<template>
  <Fragment>
    <Side v-if="isSummary" />
    <component :is="isComponent" v-if="isComponent"></component>
  </Fragment>
</template>
<script>
import { constantRoutes } from '@/router';
function getComponent(path) {
  return constantRoutes.find((i) => i.path.includes(path)) || undefined;
}
export default {
  components: {
    Side: () => import('./side'),
  },
  data() {
    return {
      title: '',
      isSummary: false,
      isComponent: '',
    };
  },
  watch: {
    '$route.meta.isSummary': {
      handler(nVal) {
        this.isSummary = nVal;
      },
      immediate: true,
      deep: true,
    },
    '$route.path': {
      handler(nVal) {
        this.isComponent = getComponent(nVal)?.component || '';
      },
      immediate: true,
    },
  },
};
</script>
